import React, { useMemo } from "react";
import moment from "moment";
import { makeStyles, Grid } from "@material-ui/core";
import { useAnalyticsState } from "../../../../../context/analytics";
import CardWarning from "../../../../cards/CardWarning";
import ChartsList from "../../../../charts/ChartsList";
import Loader from "../../../../elements/Loader";
import Layout from "../../../../layout/Layout";
import AnalyticsSettings from "../../../../sidebar/AnalyticsSettings";
import Header from "../Header";
import Fab from "../../../../elements/Fab";
import Copyright from "../../../../elements/Copyright";
import AnalyticsDateTime from "../../../../header/AnalyticsDateTime";
import { useTheme } from "@material-ui/core";

const AnalyticsLayout = ({ fieldId, loading }) => {
  const [status, setStatus] = loading;
  const {
    field,
    range: { start_date, end_date },
  } = useAnalyticsState();

  const range = useMemo(() => {
    if (!field?.timezone) {
      return { start_date, end_date };
    }
    return {
      start_date: moment(
        start_date.clone().tz(field.timezone).format("YYYY-MM-DD HH:mm:ss")
      ),
      end_date: moment(
        end_date.clone().tz(field.timezone).format("YYYY-MM-DD HH:mm:ss")
      ),
    };
  }, [end_date, start_date, field]);

  const useStyles = makeStyles((theme) => ({
    root: {
      paddingBottom: 78,
    },
    cta: {
      display: "flex",
      gap: "16px",
    },
  }));
  const { root, cta } = useStyles();
  const theme = useTheme();

  return (
    <Layout
      loading={status === "pending"}
      disableGutters={true}
      header={
        <div className={cta}>
          <Fab />
          <Grid container spacing={2}>
            <Grid item>
              <AnalyticsDateTime color={theme.palette.secondary.main} />
            </Grid>
          </Grid>
        </div>
      }
      sidebar={
        field && (
          <AnalyticsSettings
            key="analytics-settings"
            clientId={field.client_id}
            fieldId={field.id}
            loadingState={(state) => setStatus(state)}
          />
        )
      }
    >
      <Loader
        active={status === "pending"}
        showChildren={false}
        message="Loading the field..."
      >
        {field ? (
          <div className={root}>
            <Header />
            <ChartsList field={field} range={range} />
            <Copyright />
          </div>
        ) : (
          <CardWarning
            message={`Field ${fieldId} not found`}
            color="disabled"
          />
        )}
      </Loader>
    </Layout>
  );
};

export default AnalyticsLayout;
